
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goal/[goalSlug]/[goalUID]/saved/notes",
      function () {
        return require("private-next-pages/goal/[goalSlug]/[goalUID]/saved/notes.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/goal/[goalSlug]/[goalUID]/saved/notes"])
      });
    }
  